import { render, staticRenderFns } from "./LazyCascader.vue?vue&type=template&id=33db6952&scoped=true&"
import script from "./LazyCascader.vue?vue&type=script&lang=js&"
export * from "./LazyCascader.vue?vue&type=script&lang=js&"
import style0 from "./LazyCascader.vue?vue&type=style&index=0&id=33db6952&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33db6952",
  null
  
)

export default component.exports